import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <Section tone="darker" data-id="element-290" data-mp="3mf7qmi3rtqck">
      <SectionHeading eyebrow="⭐ Verified feedback" title="What dentists are saying" data-id="element-291" data-mp="3mez9uf4j20w3" />

      <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-292" data-mp="3r9lnkoy305jc">
        {testimonials.map((testimonial, index) => <article key={testimonial.name} className={`flex h-full flex-col rounded-2xl border border-white/10 bg-navy-900 p-5 ${index === 0 ? 'md:col-span-2' : ''}`} data-id="element-293" data-mp="3k7g1z9elqu" data-mpi={index}>
            <div className="flex items-center gap-1" aria-label="Rated 5 out of 5" data-id="element-294" data-mp="e1il155rae5a">
              {Array.from({
            length: 5
          }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-295" data-mp="2av3kdxe5p1eo" data-mpi={star} />)}
            </div>

            <h3 className="mt-3 font-display text-[17px] font-bold leading-snug text-gold-400 sm:text-xl" data-id="element-296" data-mp="1smm3vnwoe72v">
              “{testimonial.headline}”
            </h3>
            <p className="mt-2.5 flex-1 text-[15px] leading-relaxed text-slate-300" data-id="element-297" data-mp="1ivj2ekzu3q32">
              {testimonial.quote}
            </p>

            <div className="mt-5 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-298" data-mp="1er1m4vsonux1">
              <img src={testimonial.image} alt={`${testimonial.name}, dentist in ${testimonial.location}`} className="h-12 w-12 rounded-full object-cover" width={96} height={96} loading="lazy" data-id="element-299" data-mp="2bilv2whtx6le" />
              <div className="min-w-0" data-id="element-300" data-mp="1xlq9k4ke5mog">
                <p className="text-sm font-bold text-white" data-id="element-301" data-mp="r438e5vy712t">{testimonial.name}</p>
                <p className="text-[13px] text-slate-400" data-id="element-302" data-mp="m4gwbzruvqvl">{testimonial.location}</p>
              </div>
            </div>
          </article>)}
      </div>

      <div className="mt-10 flex justify-center" data-id="element-303" data-mp="nmfgkbax84ua">
        <CtaButton label="Join them for $27" subLabel="Instant access · 7-day guarantee" data-id="element-304" data-mp="sl8weadok7xm" />
      </div>
    </Section>;
}